import { render, staticRenderFns } from "./ListOfVenuesTableItem.vue?vue&type=template&id=719209d9&"
import script from "./ListOfVenuesTableItem.vue?vue&type=script&lang=ts&"
export * from "./ListOfVenuesTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports